import { forwardRef, type Ref, type SVGProps } from "react";
const IconEditFormOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.8 5.11 26.89 2.2a.67.67 0 0 0-.48-.2.7.7 0 0 0-.49.2L21.13 7H4a2 2 0 0 0-2 2v19a2 2 0 0 0 2 2h19a2 2 0 0 0 2-2V10.88l4.8-4.8a.68.68 0 0 0 0-.97M23 28H4V9h15.13l-3.5 3.5-4 4a.42.42 0 0 0-.14.28L11 20.22a.69.69 0 0 0 .19.58.68.68 0 0 0 .49.2l3.54-.5a.42.42 0 0 0 .28-.14l7.5-7.48zm-8.55-9.41-1.22.18.18-1.22L23.83 7.13l1 1zM26.23 6.82l-1.05-1 1.3-1.3 1.05 1z" />
  </svg>
);
const ForwardRef = forwardRef(IconEditFormOutlineSVG);
ForwardRef.displayName = "IconEditFormOutline";
export { ForwardRef as IconEditFormOutline };
